import React from 'react';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PdfCompany from '../../utils/pdf/companySchedule';
import PdfAllCompany from '../../utils/pdf/allCompanySchedule';
import PdfAllInvestors from '../../utils/pdf/allInvestorsSchedule';
import PdfInvestor from '../../utils/pdf/investorSchedule';
import GetEvent from '../../services/getEvent';
import GetCompany from '../../services/getCompany';
import GetCompanies from '../../services/getCompanies';
import GetInvestors from '../../services/getInvestors';
import GetMeetings from '../../services/getMeetings';
import GetBreaks from '../../services/getBreaks';
import Cookies from 'universal-cookie';
import PdfDocument from '../../utils/pdf/companySchedule';
import getInvestor from '../../services/getInvestor';
import SaveFile from '../../services/saveFile';
import CreateDirectory from '../../services/createDirectory';
import GetCompaniesExcel from '../../services/getCompaniesExcel';
import Constants from "../../utils/consts";
import AllMeetingsExcel from "../../utils/excel/allMeetings";
import moment from 'moment';


export default async function generateCompanyExcel(){

    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });

    var event = await GetEvent(uname, token, currentEventId);

    var scheduleType = cookies.get('scheduleType');
    var scheduleSubject = cookies.get('scheduleSubject');

    var companies = await GetCompanies(uname, token, currentEventId);
    var investors = await GetInvestors(uname, token, currentEventId);
    var company = await GetCompany(uname, token, currentEventId, scheduleSubject);
    var investor = await getInvestor(uname, token, currentEventId, scheduleSubject);
    var meetings = await GetMeetings(uname, token, currentEventId);

    var startDate = moment(event.startDate, "DD/MM/yyyy");
    var endDate = moment(event.endDate, "DD/MM/yyyy");


    var eventDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      eventDays.push(moment(tempDate));
      tempDate = tempDate.add(1, 'd');
    }

    var filterMeetings = meetings.filter((elem) => {
      for (var i = 0; i < elem.investors.length; i++){
          if (elem.investors[i].id == investor.id)
              return true;
      }
      return false;
  });

    var infoSchedules = event.brokersInfoSchedulesCompaniesEnabled;

    var jsonTabs = [];

    eventDays.map(v => {
        
      var jsonData = [];
      jsonData.push(['<b>Schedule for ' + investor.company + ' - ' + investor.name + '</b>']);

      let date = moment(v).format('DD/MM/yyyy');
      let dateComplete = moment(v).format('dddd, DD MMMM yyyy');
      
      let filterMeetingsDate = filterMeetings.filter((elem) => elem.date == date);
      let sortMeetings = filterMeetingsDate.sort((a, b) => {
          var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
          var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

          return time1 - time2;
      });

      if (sortMeetings.length <= 0) return null;

      sortMeetings.map(m => {
                  let meetingTime = moment(parseInt(m.hour)+":"+parseInt(m.minutes), "hh:mm");
                  let meetingEndTime = moment(meetingTime).add(m.slots * 5, 'minutes');

                  let strTime = moment(meetingTime).format("HH:mm");
                  let strEndTime = moment(meetingEndTime).format("HH:mm");

                  var companiesList = [];
                  m.investors.map(inv => {
                      if (inv.isAnalyst == 0 && companiesList.indexOf(inv.company) == -1)
                          companiesList.push(inv.company);
                  });

                  var meetingDesc = '';
                  if (companiesList.length == 0) meetingDesc += "Analysts Meeting with: \n";
                  else if (companiesList.length == 1) meetingDesc += "1 to 1 Meeting with: \n";
                  else if (companiesList.length < 5) meetingDesc += "1 to Few Meeting with: \n";
                  else meetingDesc += "Group Meeting with: \n";

                  var str = '<b>' + m.c_name + '</b>';
                  meetingDesc += str;
                  if (infoSchedules == 1) 
                      meetingDesc += ' (hosted by ' + m.brokerCompany+ ')';

                  meetingDesc += ', ';

                  /*
                  m.investors.map((inv, index) => {
                    if (inv.id != investor.id){
                      var str = '<b>' + inv.company + '</b>';
                      meetingDesc += str;
                      meetingDesc += ' - ' + inv.name;
                      if (infoSchedules == 1) 
                          meetingDesc += ' (hosted by ' + inv.broker+ ')';
                    }
                  });
*/
                  jsonData.push([strTime + ' - ' + strEndTime, meetingDesc]);
              }) 

              jsonTabs.push({
                name: dateComplete,
                data: jsonData
              });

            });

    var json = {
      tabs : jsonTabs
    };

    await GetCompaniesExcel(uname, token, JSON.stringify(json), investor.company + ' - ' + investor.name);
    window.location.href= Constants.mainUrl+'apis/files/'+ investor.company + ' - ' + investor.name+'.xlsx';

}